import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledLayerBodyContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: ${(props) => props.theme.size.static350};

  @media (min-width: ${Breakpoints.b560}px) {
    margin-top: ${(props) => props.theme.size.static400};
  }

  & [class^='StyledIcon-'],
  & [class*=' StyledIcon-'] {
    z-index: -1;
  }
`;

